/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from '@vlinder-web/plugin-agent-service-react';

import {
  StaticContentPlugin,
  IStaticContentPluginMethods,
  LoadingContentPlugin,
  ILoadingContentPluginMethods,
  ErrorContentPlugin,
  IErrorContentPluginMethods,
  FormatTimelineDetailPlugin,
  IFormatTimelineDetailMethods,
  IMyProfileDetailMethods,
  MyProfileDetailPlugin,
  ISendOTPMethods,
  SendOTPPlugin,
  IUpdateKycMethods,
  UpdateKycPlugin,
  IVerifyOTPMethods,
  VerifyOTPPlugin,
  IUpdateProfileMethods,
  UpdateProfilePlugin,
} from './plugins';

export type TAgent = IStaticContentPluginMethods &
  ILoadingContentPluginMethods &
  IErrorContentPluginMethods &
  IFormatTimelineDetailMethods &
  IMyProfileDetailMethods &
  ISendOTPMethods &
  IUpdateKycMethods &
  IVerifyOTPMethods &
  IUpdateProfileMethods;

const getPlugins = () => {
  return [
    new StaticContentPlugin(),
    new ErrorContentPlugin(),
    new LoadingContentPlugin(),
    new FormatTimelineDetailPlugin(),
    new MyProfileDetailPlugin(),
    new SendOTPPlugin(),
    new UpdateKycPlugin(),
    new VerifyOTPPlugin(),
    new UpdateProfilePlugin(),
  ];
};

export const getAgent = () => {
  return createAgent<TAgent>({
    plugins: getPlugins(),
  });
};
